module.exports = __webpack_public_path__ + "img/funnelni.94e53b7d.svg";